import React from 'react';
import * as pt from 'prop-types';
var slug = require('@invintusmedia/slug');
var xtend = require("xtend");
// import DB from './lib/mime-db.js';
import createReactClass from 'create-react-class';
var _ = require('underscore');
import Immutable from 'immutable';
import DB from './lib/mime-db.js';
var mime = require('mime-types')(DB);
import SentryReporter from '../../../utils/SentryReporter';
import FileUpload from '../FileUpload';
import Modal from '../Modal';
import UploadItem from './UploadItem';

function slugify (str) {
    return slug(str, {
        replacement: '-',
        lower: false,
        remove: null,
        charmap: xtend(slug.charmap, {
            '_': '-'
        })
    });
}

var Upload = createReactClass({
    propTypes: {
        uploadFn: pt.func.isRequired,
        // modal state
        open: pt.bool.isRequired,
        onClose: pt.func.isRequired,
        onOpen: pt.func.isRequired,
        uploadEventID: pt.string
    },

    getInitialState: function () {
        return {
            uploads: Immutable.List()
        };
    },

    toggleUploadModal: function (event) {
        if (event) event.preventDefault();
        this.props.onOpen();
    },

    // @XXX this is bad, but it works because we only ever have one
    // instance of this component
    uploads: [],

    handleSubmit: function (ev) {
        ev.preventDefault();
        var self = this;

        var file = ev.target.elements.media.files[0];
        var type = file.type || mime.lookup(file.name);

        if (!type) {
            this.props.emitSnack({
                type: 'error',
                message: 'File/MIME Type Unsupported'
            });
            return;
        }

        var uploadData = {
            fileName: file.name,
            eventID: this.props.uploadEventID || undefined,
            body: file,
            ContentType: type + ';charset=utf-8'
            // ContentEncoding: 'uft-8'
        };

        var index = this.state.uploads.size;
        var newUploadState = Immutable.Map({
            name: file.name,
            status: 'inProgress',
            progress: 0
        });
        this.setState({
            uploads: this.state.uploads.push(newUploadState)
        });

        // call new crud endpoint with file info
        // POST /upload/newUpload
        // {
        //  "clientID":"1000000000",
        //  "eventID":"2018091010",
        //  "fileName": "INVINTUS-bump.mp4",
        //  "fileSize": 112617062.4
        // }
        var { api, uploadEventID } = this.props;
        var _fileName = slugify(file.name);
        api.upload.newUpload({
            eventID: uploadEventID || 'MISC',
            fileName: _fileName,
            fileSize: file.size
        }, function (err, res) {
            var _err;
            try {
                _err = err || (res.errors.hasError ?
                    new Error(res.errors.message) :
                    null);
            } catch (__err) {
                _err = __err;
            }
            if (_err) {
                SentryReporter.send('CRUD upload/newUpload', 'error', _err);
                if (process.env.NODE_ENV === 'development') {
                    // console.warn('errrr', _err);
                }
            }

            // api response has the full event, with assets including
            // the new upload
            // let's not set the state from the api response though, because
            // it's hard to do that with the way things are factored.
            // Instead we can listen for an events/update socket message
            // which has the necessary data

            // start the upload once we have a response
            // this way there is not a race condition where the s3 upload
            // could finish before CRUD returns
            var up = self.props.uploadFn(uploadData, (err, s3res) => {
                self.onUploadComplete(index, err, s3res);
                if (!err) return;

                SentryReporter.send('S3', 'error', err);
                var asset = _(res.data.mediaAssets).findWhere({
                    name: _fileName
                });

                // need to call api assets/delete on the placeholder asset
                // if the upload fails
                api.assets.delete({
                    assetID: asset.assetID
                }, function (err, delRes) {
                    if (err) {
                        SentryReporter.send('CRUD assets/delete',
                            'error', err);
                    }
                });
            });

            up.on('httpUploadProgress', data => {
                self.onUploadProgress(index, data);
            });

            self.uploads.push(up);
        });

    },

    onUploadProgress: function (index, data) {
        if (!data.total) return;

        var p = data.loaded / data.total * 100;
        var percent = Math.floor(p);
        if (percent != this.state.uploads.get(index).get('progress')) {
            var newStats = this.state.uploads.get(index)
                .set('progress', Math.floor(p))
            ;
            this.setState({
                uploads: this.state.uploads.set(index, newStats)
            });
        }
    },

    onUploadComplete: function (index, err, resp) {
        if (err && err.message.indexOf('aborted by user') === -1) {
            var state = this.state.uploads.get(index);
            this.setState({
                uploads: this.state.uploads.set(index, state.merge({
                    status: 'failed',
                    message: err.message
                }))
            });
            return;
        }

        if (err && err.message.indexOf('aborted by user') > -1) return;

        var newState = this.state.uploads.get(index)
            .set('status', 'complete')
        ;
        this.setState({
            uploads: this.state.uploads.set(index, newState)
        });
    },

    clearUpload: function (i) {
        this.uploads.splice(i, 1);
        this.setState({
            uploads: this.state.uploads.delete(i)
        });
    },

    cancelUpload: function (i) {
        this.uploads[i].abort();
        var upload = this.state.uploads.get(i);
        var newStatus = upload.set('status', 'cancelled');
        this.setState({
            uploads: this.state.uploads.set(i, newStatus)
        });
    },

    render: function () {
        var iconStyle = {
            display: 'inline-block',
            fontSize: '1em',
            marginLeft: '0.5em'
        };

        var inProgress = (this.state.uploads.size &&
            this.state.uploads.every(function (upload) {
                return upload.get('status') === 'inProgress';
            }));

        var icon = inProgress ?
            (<i style={iconStyle} aria-hidden="true"
                className="fa fa-refresh fa-spin"></i>) :
            (<i style={iconStyle} className="fa fa-upload"
                aria-hidden="true"></i>);

        return (
            <li role="presentation">
                {/*
                <a href="#" onClick={this.toggleUploadModal}>
                    <span className="header-nav-text">
                        Upload {icon}
                    </span>
                    <i title="upload" className="fa fa-upload"/>
                </a>
                */}

                {this.renderModals()}
            </li>
        );
    },

    renderModals: function () {
        if (this.props.open) {
            return (<Modal modalType="upload" cancelModal={this.props.onClose}>
                <form onSubmit={this.handleSubmit}>

                    <Modal.Header>
                        Uploads
                    </Modal.Header>

                    <Modal.Body>
                        <ul className="upload-list list-unstyled">
                            {this.state.uploads.map(function (upload, i) {
                                return <UploadItem
                                    key={i}
                                    onClear={this.clearUpload.bind(this, i)}
                                    onCancel={this.cancelUpload.bind(this, i)}
                                    eventID={this.props.uploadEventID}
                                    {...upload.toJS()}
                                />;
                            }, this)}
                        </ul>
                    </Modal.Body>

                    <Modal.Footer>
                        <div className="row">
                            <div className="col-xs-8">
                                <FileUpload />
                            </div>
                            <div className="col-xs-4">
                                <button className="btn btn-link" onClick={this.props.onClose}>
                                    Close
                                </button>
                                <button id="upload-misc-asset" type="submit"
                                    className="btn btn-primary">
                                    {
                                        this.props.uploadEventID ?
                                            'Upload Event Asset' :
                                            'New Upload'
                                    }
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>

                </form>
            </Modal>);
        }
    }
});

export default Upload;
